export default __webpack_public_path__ + "static/media/Screenshot_12.f41bd57c.png";